export type PortalNavHref =
  | '/portal/dashboard'
  | '/portal/appointments'
  | '/portal/messages'
  | '/portal/questionnaires'
  | '/portal/invoices'
  | '/portal/more'
  | '/portal/treatment-courses'
  | '/portal/documents'
  | '/portal/lab-results'
  | '/portal/punch-cards'
  | '/portal/profile'
  | '/portal/clinics'
  | '/portal/data-export';

export type PortalNavItem = {
  label: string;
  href: PortalNavHref;
  icon:
    | 'home'
    | 'calendar'
    | 'message'
    | 'clipboard'
    | 'invoice'
    | 'more'
    | 'folder'
    | 'ticket'
    | 'user';
  badge?: 'messages';
};

export const PORTAL_TOP_NAV: PortalNavItem[] = [
  { label: 'Forside', href: '/portal/dashboard', icon: 'home' },
  { label: 'Aftaler', href: '/portal/appointments', icon: 'calendar' },
  { label: 'Beskeder', href: '/portal/messages', icon: 'message', badge: 'messages' },
  { label: 'Spørgeskemaer', href: '/portal/questionnaires', icon: 'clipboard' },
  { label: 'Fakturaer', href: '/portal/invoices', icon: 'invoice' },
];

export const PORTAL_TAB_NAV: PortalNavItem[] = [
  { label: 'Forside', href: '/portal/dashboard', icon: 'home' },
  { label: 'Aftaler', href: '/portal/appointments', icon: 'calendar' },
  { label: 'Beskeder', href: '/portal/messages', icon: 'message', badge: 'messages' },
  { label: 'Fakturaer', href: '/portal/invoices', icon: 'invoice' },
  { label: 'Mere', href: '/portal/more', icon: 'more' },
];

export const PORTAL_MORE_NAV: PortalNavItem[] = [
  { label: 'Forløb', href: '/portal/treatment-courses', icon: 'clipboard' },
  { label: 'Dokumenter', href: '/portal/documents', icon: 'folder' },
  { label: 'Labsvar', href: '/portal/lab-results', icon: 'clipboard' },
  { label: 'Klippekort', href: '/portal/punch-cards', icon: 'ticket' },
  { label: 'Profil', href: '/portal/profile', icon: 'user' },
  { label: 'Klinikker', href: '/portal/clinics', icon: 'home' },
  { label: 'Mine data', href: '/portal/data-export', icon: 'folder' },
];

export const PORTAL_ACCOUNT_NAV = PORTAL_MORE_NAV.filter((item) =>
  ['/portal/profile', '/portal/clinics', '/portal/data-export'].includes(item.href),
);

export function isPortalNavCurrent(pathname: string, href: string): boolean {
  if (href === '/portal/dashboard') {
    return pathname === '/portal/dashboard' || pathname === '/portal';
  }
  if (href === '/portal/more') {
    return (
      pathname === '/portal/more' ||
      PORTAL_MORE_NAV.some((item) => pathname === item.href || pathname.startsWith(`${item.href}/`))
    );
  }
  return pathname === href || pathname.startsWith(`${href}/`);
}
